function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLgChWellbalancedbod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "75.00015pt",
    height: "75pt",
    viewBox: "0 0 75.00015 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.941176%,82.745098%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 73.621094 35.59375 C 71.332031 32.710938 67.527344 30.589844 64.074219 29.371094 C 58.398438 27.367188 52.871094 27.273438 49.742188 29.515625 C 46.617188 31.757812 46.15625 36.417969 49.011719 41.269531 C 51.929688 46.222656 58.097656 51.660156 57.605469 55.765625 C 57.398438 57.476562 55.992188 58.476562 54.546875 59.324219 C 49.699219 62.167969 42.488281 63.914062 34.300781 58.996094 L 34.308594 59 C 33.429688 58.476562 32.65625 57.792969 32.035156 56.984375 C 33.21875 55.78125 34.191406 54.386719 34.917969 52.863281 L 38.199219 51.574219 C 42.222656 49.992188 39.472656 43.488281 33.539062 40.742188 C 31.835938 39.953125 30.511719 39.800781 29.777344 40.714844 C 29.375 41.214844 28.957031 41.703125 28.53125 42.183594 C 28.148438 42.089844 27.753906 42 27.34375 41.933594 C 21.746094 40.996094 13.683594 42.277344 10.925781 39.242188 C 9.777344 37.976562 9.9375 36.238281 10.238281 34.566406 C 11.242188 28.960938 14.59375 22.230469 23.570312 19.050781 C 24.859375 18.550781 26.269531 18.449219 27.617188 18.765625 C 29.195312 19.242188 28.875 20.257812 28.554688 21.199219 L 26.617188 26.871094 C 25.203125 31.019531 31.855469 33.085938 37.746094 30.25 C 39.4375 29.4375 40.410156 28.507812 40.199219 27.34375 L 40.199219 27.347656 C 39.667969 24.421875 39.449219 21.445312 39.542969 18.472656 C 39.660156 14.570312 40.261719 10.457031 38.082031 7.195312 C 35.898438 3.933594 29.859375 1.832031 23.574219 3.703125 C 17.34375 5.558594 13.914062 10.148438 11.460938 14.132812 C 6.058594 22.917969 1.058594 31.945312 0.753906 40.472656 C 0.453125 49 12.054688 64.636719 15.699219 64.722656 C 16.582031 64.734375 17.460938 64.667969 18.332031 64.515625 C 19.535156 66.246094 21.054688 67.738281 22.808594 68.914062 C 28.226562 72.554688 33.882812 72.253906 38.453125 71.585938 C 48.527344 70.105469 58.523438 68.15625 65.109375 62.878906 C 71.691406 57.601562 75.910156 38.476562 73.621094 35.59375 Z M 73.621094 35.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 59.050781 67.53125 L 15.953125 67.53125 L 9 19.804688 C 27.023438 11.195312 47.976562 11.195312 66 19.804688 Z M 59.050781 67.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.5 13.347656 C 47.363281 13.34375 57.101562 15.550781 66 19.804688 L 59.050781 67.53125 L 15.953125 67.53125 L 9 19.804688 C 17.898438 15.550781 27.636719 13.34375 37.5 13.347656 M 37.5 11.847656 C 27.414062 11.859375 17.457031 14.113281 8.351562 18.449219 C 7.761719 18.734375 7.421875 19.371094 7.515625 20.019531 L 14.46875 67.75 C 14.574219 68.484375 15.207031 69.03125 15.953125 69.03125 L 59.050781 69.03125 C 59.792969 69.03125 60.425781 68.484375 60.53125 67.75 L 67.484375 20.019531 C 67.578125 19.371094 67.238281 18.734375 66.648438 18.449219 C 57.542969 14.113281 47.585938 11.859375 37.5 11.847656 Z M 37.5 11.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.3125 61.683594 L 13.800781 23.828125 C 13.664062 22.894531 14.191406 21.988281 15.074219 21.644531 C 29.5 16.039062 45.503906 16.039062 59.929688 21.644531 C 60.808594 21.988281 61.335938 22.894531 61.199219 23.828125 L 55.6875 61.683594 C 55.53125 62.703125 54.652344 63.449219 53.625 63.441406 L 21.378906 63.441406 C 20.347656 63.449219 19.46875 62.703125 19.3125 61.683594 Z M 19.3125 61.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.5 17.441406 C 45.171875 17.449219 52.773438 18.875 59.925781 21.644531 C 60.808594 21.988281 61.335938 22.894531 61.199219 23.828125 L 55.6875 61.683594 C 55.53125 62.703125 54.652344 63.449219 53.625 63.441406 L 21.378906 63.441406 C 20.347656 63.449219 19.46875 62.703125 19.3125 61.683594 L 13.800781 23.828125 C 13.664062 22.894531 14.191406 21.988281 15.074219 21.644531 C 22.226562 18.875 29.828125 17.449219 37.5 17.441406 M 37.5 16.691406 C 29.738281 16.707031 22.042969 18.148438 14.800781 20.945312 C 13.589844 21.410156 12.867188 22.65625 13.058594 23.9375 L 18.570312 61.792969 C 18.789062 63.175781 19.980469 64.195312 21.378906 64.191406 L 53.621094 64.191406 C 55.023438 64.195312 56.210938 63.175781 56.429688 61.792969 L 61.941406 23.9375 C 62.132812 22.65625 61.410156 21.410156 60.199219 20.945312 C 52.957031 18.148438 45.261719 16.707031 37.5 16.691406 Z M 37.5 16.691406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 50.503906 24.28125 L 50.503906 29.828125 L 24.496094 29.828125 L 24.496094 24.28125 L 50.503906 24.28125 M 50.503906 22.78125 L 24.496094 22.78125 C 23.667969 22.78125 22.996094 23.453125 22.996094 24.28125 L 22.996094 29.828125 C 22.996094 30.226562 23.15625 30.609375 23.4375 30.890625 C 23.71875 31.171875 24.101562 31.328125 24.496094 31.328125 L 50.503906 31.328125 C 50.902344 31.328125 51.28125 31.171875 51.5625 30.890625 C 51.84375 30.609375 52.003906 30.226562 52.003906 29.828125 L 52.003906 24.28125 C 52.003906 23.886719 51.84375 23.503906 51.5625 23.222656 C 51.28125 22.941406 50.902344 22.78125 50.503906 22.78125 Z M 50.503906 22.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.019608%,43.529412%,64.705882%)",
      fillOpacity: 1
    },
    d: "M 24.496094 24.28125 L 50.5 24.28125 L 50.5 29.828125 L 24.496094 29.828125 Z M 24.496094 24.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,37.254902%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 50.503906 29.828125 L 24.496094 29.828125 L 50.503906 24.28125 Z M 50.503906 29.828125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.5 60.527344 C 37.085938 60.527344 36.75 60.191406 36.75 59.777344 L 36.75 53.753906 C 36.75 53.339844 37.085938 53.003906 37.5 53.003906 C 37.914062 53.003906 38.25 53.339844 38.25 53.753906 L 38.25 59.777344 C 38.25 59.976562 38.171875 60.164062 38.03125 60.304688 C 37.890625 60.445312 37.699219 60.527344 37.5 60.527344 Z M 37.5 60.527344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.5 46.792969 C 37.085938 46.792969 36.75 46.457031 36.75 46.042969 L 36.75 36.433594 C 36.75 36.019531 37.085938 35.683594 37.5 35.683594 C 37.914062 35.683594 38.25 36.019531 38.25 36.433594 L 38.25 46.042969 C 38.25 46.242188 38.171875 46.433594 38.03125 46.574219 C 37.890625 46.714844 37.699219 46.792969 37.5 46.792969 Z M 37.5 46.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 21.347656 35.011719 L 18.632812 35.011719 C 18.21875 35.011719 17.882812 34.675781 17.882812 34.261719 C 17.882812 33.847656 18.21875 33.511719 18.632812 33.511719 L 21.347656 33.511719 C 21.761719 33.511719 22.097656 33.847656 22.097656 34.261719 C 22.097656 34.675781 21.761719 35.011719 21.347656 35.011719 Z M 21.347656 35.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 26.214844 40.15625 L 19.488281 40.15625 C 19.074219 40.15625 18.738281 39.820312 18.738281 39.40625 C 18.738281 38.992188 19.074219 38.65625 19.488281 38.65625 L 26.214844 38.65625 C 26.628906 38.65625 26.964844 38.992188 26.964844 39.40625 C 26.964844 39.820312 26.628906 40.15625 26.214844 40.15625 Z M 26.214844 40.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 33.164062 45.300781 L 20.34375 45.300781 C 19.929688 45.300781 19.59375 44.964844 19.59375 44.550781 C 19.59375 44.136719 19.929688 43.800781 20.34375 43.800781 L 33.164062 43.800781 C 33.582031 43.800781 33.914062 44.136719 33.914062 44.550781 C 33.914062 44.964844 33.582031 45.300781 33.164062 45.300781 Z M 33.164062 45.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 33.164062 50.445312 L 21.199219 50.445312 C 20.78125 50.445312 20.449219 50.109375 20.449219 49.695312 C 20.449219 49.28125 20.78125 48.945312 21.199219 48.945312 L 33.167969 48.945312 L 33.164062 48.945312 C 33.582031 48.945312 33.914062 49.28125 33.914062 49.695312 C 33.914062 50.109375 33.582031 50.445312 33.164062 50.445312 Z M 33.164062 50.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 33.164062 55.589844 L 22.050781 55.589844 C 21.636719 55.589844 21.300781 55.253906 21.300781 54.839844 C 21.300781 54.425781 21.636719 54.089844 22.050781 54.089844 L 33.164062 54.089844 C 33.582031 54.089844 33.914062 54.425781 33.914062 54.839844 C 33.914062 55.253906 33.582031 55.589844 33.164062 55.589844 Z M 33.164062 55.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 33.164062 60.738281 L 22.90625 60.738281 C 22.492188 60.738281 22.15625 60.402344 22.15625 59.988281 C 22.15625 59.574219 22.492188 59.238281 22.90625 59.238281 L 33.164062 59.238281 C 33.582031 59.238281 33.914062 59.574219 33.914062 59.988281 C 33.914062 60.402344 33.582031 60.738281 33.164062 60.738281 Z M 33.164062 60.738281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 56.054688 35.011719 L 53.335938 35.011719 C 52.921875 35.011719 52.585938 34.675781 52.585938 34.261719 C 52.585938 33.847656 52.921875 33.511719 53.335938 33.511719 L 56.054688 33.511719 C 56.46875 33.511719 56.804688 33.847656 56.804688 34.261719 C 56.804688 34.675781 56.46875 35.011719 56.054688 35.011719 Z M 56.054688 35.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 55.199219 40.15625 L 48.472656 40.15625 C 48.058594 40.15625 47.722656 39.820312 47.722656 39.40625 C 47.722656 38.992188 48.058594 38.65625 48.472656 38.65625 L 55.199219 38.65625 C 55.613281 38.65625 55.949219 38.992188 55.949219 39.40625 C 55.949219 39.820312 55.613281 40.15625 55.199219 40.15625 Z M 55.199219 40.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 54.34375 45.300781 L 41.519531 45.300781 C 41.105469 45.300781 40.769531 44.964844 40.769531 44.550781 C 40.769531 44.136719 41.105469 43.800781 41.519531 43.800781 L 54.34375 43.800781 C 54.757812 43.800781 55.09375 44.136719 55.09375 44.550781 C 55.09375 44.964844 54.757812 45.300781 54.34375 45.300781 Z M 54.34375 45.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 53.488281 50.445312 L 41.519531 50.445312 C 41.105469 50.445312 40.769531 50.109375 40.769531 49.695312 C 40.769531 49.28125 41.105469 48.945312 41.519531 48.945312 L 53.488281 48.945312 C 53.902344 48.945312 54.238281 49.28125 54.238281 49.695312 C 54.238281 50.109375 53.902344 50.445312 53.488281 50.445312 Z M 53.488281 50.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 52.632812 55.589844 L 41.519531 55.589844 C 41.105469 55.589844 40.769531 55.253906 40.769531 54.839844 C 40.769531 54.425781 41.105469 54.089844 41.519531 54.089844 L 52.632812 54.089844 C 53.046875 54.089844 53.382812 54.425781 53.382812 54.839844 C 53.382812 55.253906 53.046875 55.589844 52.632812 55.589844 Z M 52.632812 55.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 51.777344 60.738281 L 41.519531 60.738281 C 41.105469 60.738281 40.769531 60.402344 40.769531 59.988281 C 40.769531 59.574219 41.105469 59.238281 41.519531 59.238281 L 51.777344 59.238281 C 52.191406 59.238281 52.527344 59.574219 52.527344 59.988281 C 52.527344 60.402344 52.191406 60.738281 51.777344 60.738281 Z M 51.777344 60.738281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 53.246094 23.21875 C 53.246094 31.914062 46.195312 38.964844 37.5 38.964844 C 28.804688 38.964844 21.753906 31.914062 21.753906 23.21875 C 21.753906 14.519531 28.804688 7.46875 37.5 7.46875 C 46.195312 7.46875 53.246094 14.519531 53.246094 23.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 51.535156 23.21875 C 51.539062 25.476562 50.992188 27.703125 49.949219 29.703125 L 45.203125 26.929688 C 46.34375 24.585938 46.34375 21.851562 45.203125 19.507812 L 49.949219 16.734375 L 49.945312 16.734375 C 50.992188 18.734375 51.539062 20.960938 51.535156 23.21875 Z M 51.535156 23.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 49.257812 15.550781 L 44.511719 18.324219 C 43.054688 16.226562 40.730469 14.894531 38.183594 14.695312 L 38.183594 9.203125 C 42.679688 9.417969 46.800781 11.78125 49.257812 15.550781 Z M 49.257812 15.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 28.941406 23.21875 C 28.945312 24.503906 29.238281 25.773438 29.796875 26.929688 L 25.050781 29.703125 C 22.933594 25.640625 22.933594 20.796875 25.050781 16.734375 L 29.796875 19.507812 C 29.234375 20.664062 28.941406 21.933594 28.941406 23.21875 Z M 28.941406 23.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 36.816406 9.203125 L 36.816406 14.695312 C 34.269531 14.894531 31.945312 16.226562 30.488281 18.324219 L 25.742188 15.550781 L 25.746094 15.550781 C 28.199219 11.78125 32.320312 9.417969 36.816406 9.203125 Z M 36.816406 9.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.484375 7.46875 C 42.617188 7.460938 47.433594 9.957031 50.386719 14.15625 C 53.34375 18.355469 54.0625 23.730469 52.324219 28.558594 C 50.582031 33.390625 46.597656 37.070312 41.640625 38.417969 C 36.6875 39.765625 31.386719 38.617188 27.441406 35.335938 C 23.492188 32.054688 21.386719 27.054688 21.804688 21.9375 C 22.222656 16.820312 25.109375 12.226562 29.539062 9.628906 C 31.949219 8.21875 34.691406 7.46875 37.484375 7.46875 M 37.484375 5.96875 L 37.484375 7.46875 L 37.484375 5.96875 C 31.316406 5.96875 25.613281 9.257812 22.53125 14.601562 C 19.445312 19.945312 19.445312 26.527344 22.53125 31.871094 C 25.613281 37.214844 31.316406 40.507812 37.484375 40.507812 C 43.65625 40.507812 49.355469 37.214844 52.441406 31.871094 C 55.527344 26.527344 55.527344 19.945312 52.441406 14.601562 C 49.355469 9.257812 43.65625 5.96875 37.488281 5.96875 Z M 37.484375 5.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 41.769531 34.585938 L 33.230469 34.585938 C 32.816406 34.585938 32.480469 34.25 32.480469 33.835938 C 32.480469 33.421875 32.816406 33.085938 33.230469 33.085938 L 41.769531 33.085938 C 42.183594 33.085938 42.519531 33.421875 42.519531 33.835938 C 42.519531 34.25 42.183594 34.585938 41.769531 34.585938 Z M 41.769531 34.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 37.519531 28.277344 C 35.121094 28.285156 33.046875 26.613281 32.550781 24.265625 C 32.054688 21.917969 33.273438 19.546875 35.46875 18.582031 L 37.46875 15.191406 L 39.496094 18.566406 C 41.699219 19.511719 42.9375 21.875 42.457031 24.226562 C 41.980469 26.574219 39.917969 28.269531 37.519531 28.277344 Z M 37.519531 28.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 42.558594 23.246094 C 42.546875 26.039062 40.269531 28.292969 37.476562 28.28125 C 34.679688 28.265625 32.425781 25.988281 32.441406 23.195312 L 32.441406 23.1875 Z M 42.558594 23.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.46875 15.195312 L 39.496094 18.566406 L 39.488281 18.570312 L 39.488281 18.566406 C 41.34375 19.359375 42.554688 21.179688 42.5625 23.195312 C 42.570312 24.097656 42.332031 24.980469 41.875 25.757812 C 40.976562 27.3125 39.316406 28.273438 37.519531 28.28125 L 37.503906 28.28125 C 34.71875 28.277344 32.453125 26.027344 32.4375 23.238281 C 32.433594 22.339844 32.671875 21.460938 33.121094 20.683594 L 33.125 20.675781 C 33.667969 19.746094 34.488281 19.015625 35.472656 18.582031 L 37.46875 15.195312 M 37.46875 13.695312 L 37.464844 13.695312 C 36.933594 13.699219 36.445312 13.980469 36.179688 14.433594 L 34.410156 17.433594 C 31.746094 18.851562 30.394531 21.902344 31.128906 24.828125 C 31.863281 27.75 34.5 29.800781 37.515625 29.792969 C 40.53125 29.785156 43.15625 27.722656 43.875 24.792969 C 44.59375 21.863281 43.226562 18.820312 40.554688 17.417969 L 38.753906 14.425781 L 38.757812 14.421875 C 38.484375 13.972656 37.996094 13.695312 37.46875 13.695312 Z M 37.46875 13.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 36.613281 18.441406 L 37.472656 16.703125 L 38.347656 18.433594 Z M 36.613281 18.441406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.5 21.164062 C 38.628906 21.167969 39.542969 22.082031 39.546875 23.214844 C 39.546875 24.34375 38.636719 25.261719 37.507812 25.269531 L 37.5 25.269531 C 36.371094 25.265625 35.457031 24.351562 35.453125 23.222656 C 35.453125 22.089844 36.363281 21.171875 37.492188 21.164062 L 37.5 21.164062 M 37.5 19.664062 L 37.488281 19.664062 C 35.523438 19.667969 33.933594 21.261719 33.933594 23.226562 C 33.933594 25.191406 35.527344 26.785156 37.492188 26.785156 C 39.457031 26.785156 41.050781 25.191406 41.054688 23.226562 C 41.054688 21.261719 39.464844 19.667969 37.5 19.664062 Z M 37.5 19.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.90625 23.21875 C 38.90625 25.09375 36.09375 25.09375 36.09375 23.21875 C 36.09375 21.34375 38.90625 21.34375 38.90625 23.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 47.683594 29.605469 C 47.167969 29.605469 46.6875 29.339844 46.414062 28.90625 C 46.140625 28.46875 46.109375 27.921875 46.332031 27.457031 C 47.65625 24.699219 47.613281 21.476562 46.21875 18.753906 C 44.824219 16.027344 42.234375 14.113281 39.21875 13.574219 C 36.207031 13.039062 33.113281 13.9375 30.863281 16.011719 C 28.609375 18.085938 27.457031 21.09375 27.746094 24.140625 C 27.824219 24.96875 27.21875 25.699219 26.394531 25.777344 C 25.570312 25.855469 24.835938 25.25 24.757812 24.421875 C 24.382812 20.441406 25.890625 16.515625 28.828125 13.804688 C 31.769531 11.097656 35.808594 9.917969 39.746094 10.621094 C 43.683594 11.324219 47.066406 13.824219 48.886719 17.382812 C 50.710938 20.941406 50.765625 25.148438 49.035156 28.753906 C 48.789062 29.273438 48.261719 29.605469 47.683594 29.605469 Z M 47.683594 29.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 29.875 22.84375 L 26.757812 29.640625 L 22.425781 23.542969 Z M 29.875 22.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.5 7.46875 C 43.117188 7.472656 48.308594 10.464844 51.125 15.328125 C 53.9375 20.1875 53.949219 26.179688 51.15625 31.054688 C 48.359375 35.925781 43.179688 38.941406 37.5625 38.964844 L 37.496094 38.964844 L 37.5 38.964844 C 31.882812 38.960938 26.691406 35.96875 23.875 31.105469 C 21.0625 26.246094 21.050781 20.253906 23.847656 15.382812 C 26.640625 10.507812 31.820312 7.496094 37.4375 7.46875 L 37.503906 7.46875 M 37.503906 5.96875 L 37.429688 5.96875 C 31.277344 5.996094 25.605469 9.296875 22.542969 14.632812 C 19.480469 19.96875 19.492188 26.535156 22.578125 31.859375 C 25.660156 37.183594 31.34375 40.464844 37.5 40.464844 L 37.570312 40.464844 C 43.722656 40.4375 49.394531 37.136719 52.457031 31.800781 C 55.519531 26.464844 55.507812 19.902344 52.421875 14.574219 C 49.339844 9.25 43.65625 5.972656 37.503906 5.96875 Z M 37.503906 5.96875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLgChWellbalancedbod);
export default __webpack_public_path__ + "static/media/ic_lg_ch_wellbalancedbod.076ff74c572ccd9da2ade4d8315fa657.svg";
export { ForwardRef as ReactComponent };